import { admessageService } from '../services';
import { showToast } from '../services/toast';

export const admessageActions = {
    fetchAdMessage,
    submitAdmessage
};

function fetchAdMessage() {
    return dispatch => {

        return admessageService.fetchAdMessage()
            .then(
                response => {
                    return response;
                },
                error => {
                    // showToast(error.toString(), 'error');
                    throw error;
                }
            );
    };

}


function submitAdmessage(payload) {
    return dispatch => {

        return admessageService.submitAdmessage(payload)
            .then(
                response => {
                    return response;
                },
                error => {
                    showToast(error.toString(), 'error');
                    throw error;
                }
            );
    };
}